<div class="fdk-textarea">
  <label
    class="fdk-textarea__label"
    [for]="textareaId">
    {{ label }}
    @if (required) {
      <span
        class="fdk-textarea__required"
        aria-hidden="true">*</span>
    }
  </label>

  <textarea
    class="fdk-textarea__control"
    (blur)="handleBlur()"
    (input)="handleInput($event)"
    rows="3"
    [class.fdk-textarea__control--error]="error"
    [attr.aria-describedby]="describedBy"
    [attr.aria-invalid]="error ? 'true' : null"
    [disabled]="disabled"
    [id]="textareaId"
    [attr.name]="name"
    [placeholder]="placeholder"
    [required]="required"
    [value]="value"></textarea>

  @if (showErrorMessage) {
    <p
      class="fdk-textarea__error"
      [id]="errorMessageId">
      {{ errorMessage }}
    </p>
  }
</div>
